import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../../helpers/history';

// 引入 ECharts 主模块
import echarts from 'echarts/lib/echarts';
import 'echarts-gl';

// 引入柱状图
import "echarts/lib/chart/bar";

// 引入提示框和标题组件
import "echarts/lib/component/tooltip";
import 'echarts/lib/component/title';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/scatter';//effectScatter
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/axisPointer';
import 'echarts/lib/component/markArea';
import 'echarts/lib/component/legendScroll';

import { Layout, Table, Divider, Button, message, Select, Spin } from 'antd';
import { getChartOption } from './chartOptions/index';

import emitter from '../Evt.js';

import moment from 'moment';
var moment_timezone = require('moment-timezone');

const { Content } = Layout;
const Option = Select.Option;
var languageMessages = window.appLocale.messages;

var incomes = {
    'sName': languageMessages['incomeCurve'],
    'xName': languageMessages['date'],
    'xData': [],
    'yName': languageMessages['totalRet'] + '(%)',
    'data': [
        {
            'name': languageMessages['strategyGains'],
            'color': '#ee6666',
            'data': []//[0.00, - 0.18, -0.55, 0.19, -0.96, 0.29, 0.26]
        },
        {
            'name': languageMessages['individualStockIncome'],
            'color': '#5470c6',
            'data': []//[0.73, 1.06, 1.76, 3.19, 1.98, 3.67, 3.26]
        },
        {
            'name': languageMessages['individualStocks+strategyStackingIncome'],
            'color': '#990000',
            'data': []//[0.73, 1.06, 1.76, 3.19, 1.98, 3.67, 3.26]
        }
    ],
};

var wts = {
    'sName': 'wT',
    'xData': [],
    'data': []
};

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

var colors = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];

function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

class PortfolioResult extends Component {
    constructor(props) {
        super(props);

        window.webType === 'US' ? moment_timezone.tz.setDefault("America/New_York") : moment_timezone.tz.setDefault("Asia/Shanghai");

        this.charts = {
            "income": null,
            "wt": null
        }
        
        this.state = {
            spinLoadding: false,

            statisticsResult: [],

            portfolioDataSource: [],
            dataSource: []

        }
    }
    
    componentDidMount() {
        const { statisticsResult } = this.props;
        
        this.setBacktestResult(statisticsResult);
        
    }

    setBacktestResult(statisticsResult) {

        this.charts = {
            "income": null,
            "wt": null
        };

        incomes.xData = [];
        incomes.data[0].data = [];
        incomes.data[1].data = [];
        incomes.data[2].data = [];
        
        wts.xData = [];
        wts.data = [];
        
        var dataSource = [];
        
        var portfolioDataSource = [];

        if (statisticsResult.portfolioOptResult != null && statisticsResult.portfolioOptResult.length > 0) {
            var portfolioOptResult = statisticsResult.portfolioOptResult;
            
            var index = 1;
            for (var ii in portfolioOptResult) {
                portfolioDataSource.push({
                    key: index,//trades[item].backtestId,
                    section: portfolioOptResult[ii].S,
                    maximizing: portfolioOptResult[ii].R,
                    minimize: portfolioOptResult[ii].V,
                    benchmarking: portfolioOptResult[ii].B,
                });
                

                var wtData = [];
                
                var wT = portfolioOptResult[ii].wT;
                for (let key in wT) {
                    wtData.push(wT[key]);

                    if(index == 1) wts.xData.push(key);
                }
                
                wts.data.push({ 'data': wtData, 'name': portfolioOptResult[ii].S });

                index++;
            }
        }

        var items = this.setPortfolioResult(statisticsResult);

        incomes = items.incomes;
        dataSource = items.dataSource;

        this.setIncomeData("income", incomes);
        this.setWtData("wt", wts);

        this.setState({ portfolioDataSource, dataSource, statisticsResult });
    }

    componentWillUnmount() {
    }

    resizeChart() {
        var incomeChart = this.charts['income'];
        var wtChart = this.charts['wt'];
        
        window.onresize = function () {
            if (incomeChart != null) incomeChart.resize();
            if (wtChart != null) wtChart.resize();
        }
    }

    setWtData(chartName, chartData) {
        this.charts[chartName] = echarts.init(document.getElementById(chartName));
        this.charts[chartName].setOption(getChartOption(chartName, chartData));

        this.charts[chartName].resize();

        this.resizeChart();
    }

    setIncomeData(chartName, chartData) {
        this.charts[chartName] = echarts.init(document.getElementById(chartName));
        this.charts[chartName].setOption(getChartOption(chartName, chartData));

        this.charts[chartName].resize();

        this.resizeChart();
    }

    keepDecimals(value, sign) {
        value = value == null ? '' : value;
        if (value !== '') {
            //value = value.replace(/([0-9]+.[0-9]{2})[0-9]*/, "$1");
            value = Number(value).toFixed(2);
            value += sign;
        }

        return value;
    }

    setPortfolioResult(statisticsResult) {

        if (statisticsResult.equityCurve != null) {
            var rateOfReturn = statisticsResult.equityCurve.rateOfReturn;
            var bRateOfReturn = statisticsResult.equityCurve.bRateOfReturn;

            incomes.xData = statisticsResult.equityCurve.date;
            //incomes.data[0].name = '策略收益';//window.webType === 'US' ? languageMessages['SP500'] : languageMessages['CSI300'];
            incomes.data[0].data = rateOfReturn;
            //incomes.data[1].name = '个股收益';//strategyName;
            incomes.data[1].data = bRateOfReturn;

            var superimposedIncome = [];
            for (var ii in rateOfReturn) {
                var tmp = parseFloat(rateOfReturn[ii]) + parseFloat(bRateOfReturn[ii]);
                superimposedIncome.push(this.keepDecimals(tmp.toString(), ''));
            }

            incomes.data[2].data = superimposedIncome;
        }
        
        var dataSource = [];
        if (statisticsResult.trades != null && statisticsResult.trades.length > 0) {
            var trades = statisticsResult.trades;
            
            
            var sequence = 1;
            var index = 1;
            for (var ii in trades) {
                var symbol = '';
                var pnl = parseFloat(trades[ii].pnl);
                var pnlPercent = parseFloat(trades[ii].pnlPercent);

                var direction = '';
                var tradeTime = trades[ii].entryDatetime;
                var strikePrice = '';
                var volume = Math.abs(trades[ii].quantity);
                var turnover = 0;
                if (trades[ii].direction == 'L') {
                    direction = 'L';
                } else {
                    direction = 'S';
                }

                tradeTime = trades[ii].entryDatetime;
                strikePrice = trades[ii].entryPrice;
                var tmpStrikePrice = parseFloat(strikePrice);
                turnover = volume * tmpStrikePrice;

                dataSource.push({
                    key: index,//trades[item].backtestId,
                    sequence: sequence,
                    symbolName: symbol,
                    tradeTime: tradeTime,
                    strikePrice: strikePrice,
                    direction: direction,
                    volume: volume,
                    turnover: turnover.toFixed(2),
                    pnl: '',
                    pnlp: ''
                });

                index++;

                if (trades[ii].direction == 'L') {
                    direction = 'S';
                } else {
                    direction = 'L';
                }

                tradeTime = trades[ii].exitDatetime;
                strikePrice = trades[ii].exitPrice;
                var tmpStrikePrice = parseFloat(strikePrice);
                turnover = volume * tmpStrikePrice;

                dataSource.push({
                    key: index,//trades[item].backtestId,
                    sequence: '',
                    symbolName: '',
                    tradeTime: tradeTime,
                    strikePrice: strikePrice,
                    direction: direction,
                    volume: volume,
                    turnover: turnover.toFixed(2),
                    pnl: pnl.toFixed(2),
                    pnlp: pnlPercent.toFixed(2)
                });

                sequence++;
                index++;
            }
        }

        return { incomes, dataSource };
    }

    componentWillReceiveProps(props) {
        var { status, statisticsResult } = props;
        
        switch (status) {
            default:
                if (this.state.statisticsResult == statisticsResult) return;

                this.setBacktestResult(statisticsResult);
                break;
        }
    }

    render() {
        var { portfolioDataSource, dataSource } = this.state;

        const portfolioColumns = [
            {
                title: 'Section',
                dataIndex: 'section',
                align: 'center',
                //width: 200
            }, {
                title: languageMessages['Maximizing returns'],
                dataIndex: 'maximizing',
                align: 'right',
                sorter: (a, b) => a.maximizing - b.maximizing,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['Minimize variance'],
                dataIndex: 'minimize',
                align: 'right',
                sorter: (a, b) => a.minimize - b.minimize,
                sortDirections: ['descend', 'ascend'],
                //width: 50
            }, {
                title: languageMessages['Benchmarking income'],
                dataIndex: 'benchmarking',
                //fixed: 'right',
                align: 'right',
                sorter: (a, b) => a.benchmarking - b.benchmarking,
                sortDirections: ['descend', 'ascend'],
            }
        ];

        const columns = [
            {
                title: languageMessages['sequence'],
                dataIndex: 'sequence',
                align: 'right',
                width: 50
            }, {
                title: languageMessages['symbolCode'],
                dataIndex: 'symbolName',
                //sorter: (a, b) => a.symbolName < b.symbolName ? -1 : a.symbolName > b.symbolName ? 1 : 0,
                //sortDirections: ['descend', 'ascend'],
                //render: (text, record) => <a onClick={() => this.selectRow(record)}>{text}</a>,
            }, {
                title: languageMessages['direction'],
                dataIndex: 'direction',
                //sorter: (a, b) => a.direction < b.direction ? -1 : a.direction > b.direction ? 1 : 0,
                //sortDirections: ['descend', 'ascend'],
                render: (text, record) => (
                    <span>
                        {languageMessages.hasOwnProperty(record.direction) ? languageMessages[record.direction] : record.direction}
                    </span>
                )
            }, {
                title: languageMessages['tradeTimes'],
                dataIndex: 'tradeTime',
                //sorter: (a, b) => a.tradeTimes - b.tradeTimes,
                //sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['strikePrice'],
                dataIndex: 'strikePrice',
                align: 'right',
                //sorter: (a, b) => a.strikePrice - b.strikePrice,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['tradeSize'],
                dataIndex: 'volume',
                align: 'right',
                //sorter: (a, b) => a.volume - b.volume,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['dollars'],
                dataIndex: 'turnover',
                align: 'right',
                //sorter: (a, b) => a.turnover - b.turnover,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['pnls'],
                dataIndex: 'pnl',
                align: 'right',
                //sorter: (a, b) => a.pnl - b.pnl,
                //sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['pnl'] !== '' && row['pnl'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }, {
                title: languageMessages['gain'] + '(%)',
                dataIndex: 'pnlp',
                align: 'right',
                //sorter: (a, b) => a.pnlp - b.pnlp,
                //sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['pnlp'] !== '' && row['pnlp'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }
        ];

        return (<Content>
            <Spin spinning={this.state.spinLoadding}>
                <div className='common-title'><Divider type="vertical" />{languageMessages['Portfolio opt info']}</div>

                <Table bordered size='small' locale={{ emptyText: ' ' }}
                    columns={portfolioColumns}
                    dataSource={portfolioDataSource} pagination={false} />

                <div id="wt" style={{ height: "500px", marginTop: "20px" }} > </div>

                <div className='common-title'><Divider type="vertical" />{languageMessages['fundsCurve']}</div>
                <div id="income" style={{ height: "500px", marginTop: "20px" }} > </div>

                <div className='common-title'><Divider type="vertical" />{languageMessages['tradeDetails']}</div>
                <Table bordered size='small' locale={{ emptyText: ' ' }} columns={columns} dataSource={dataSource} pagination={dataSource.length >= 40 ? { pageSize: 40 } : false} />
            </Spin>
            
        </Content>);
    }
}

export { PortfolioResult as default }
